import { lazy } from "react";
import { rutasDaleGrupoAvalPublic } from "../../apps/Corresponsalia/CorresponsaliaGrupoAval/routes";
import { rutasPublicasBilleteraBancoW } from "../../apps/BancoW/routes.jsx";

const PublicHome = lazy(() => import("."));

export const publicUrls = [
  { link: "", label: "Inicio", component: PublicHome },
  {
    link: "",
    label: "Inicio",
    component: PublicHome,
    subRoutes: [rutasDaleGrupoAvalPublic, rutasPublicasBilleteraBancoW],
  },
];
